import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patheader',
  templateUrl: './patheader.component.html',
  styleUrls: ['./patheader.component.css']
})
export class PatheaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
